import { combineReducers } from 'redux'

import deleteNode from './inventories/delete'
import get from './inventories/get'
import list from './inventories/list'
import post from './inventories/post'
import put from './inventories/put'
import view from './inventories/view'

export default combineReducers({
  delete: deleteNode,
  get,
  list,
  post,
  put,
  view
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/inventories.js